export default __webpack_public_path__ + "static/media/Other_Gov.3b891d1b.svg";